<template>
   <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
  >
      <template #layoutContent>
        <Card class="card p-5" :title="response.contact ? response?.contact.firstname : response.email">
            <br>
            <Card class="card p-5 mx-10 mb-2">
                <h4>{{ response.nps?.nps_description }}</h4>
                <div class="p-4 back">
                  <p>{{ response.note }}</p>
                </div>
            </Card>
            <Card class="card p-5 mx-10 mb-2" v-for="(resp, index) in response.data" :key="index">
                <h4>{{ resp.label }}</h4>
                <div class="p-4 back">
                  <p>{{ displayValue(resp?.value) }}</p>
                </div>
            </Card>
        </Card> 
      </template>
  </SubLayout>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import { useRoute} from "vue-router";
import Card from "@/components/Card.vue";

const title = ref("breadcrumbs.nps")
const breadcrumbs = ref([
{
  name: 'breadcrumbs.views',
  route: 'nps'
}
])

const route = useRoute()
const store = useStore()
const response = ref({})
const getting = ref(false)

async function loadNpsResponse() {
  getting.value = true
  await store.dispatch('nps/getNpsResponse', route.params.response).then((res) => {
    response.value = {...res?.data?.response, data: JSON.parse(res?.data?.response?.data)}
  }).finally(() => {getting.value = false})
} 


const displayValue = (resp) => {
  return Array.isArray(resp) ? resp.join(', ') : resp;
};


onMounted(async() => {
  loadNpsResponse()
})

</script>

<style scoped>
.back{
  background-color: var(--bs-light-primary);
  border-radius: 8px;
  padding: 5px;
  width: auto;
}
</style>
